module.exports = "<div class=\"ui active inverted page dimmer\" *ngIf=\"show\">\n  <div class=\"ui text loader\">{{message}}</div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/components/loading/loading.component.html
// module id = 1016
// module chunks = 0